import { render, staticRenderFns } from "./UNMoreProject.vue?vue&type=template&id=08af9a61&scoped=true&"
import script from "./UNMoreProject.vue?vue&type=script&lang=js&"
export * from "./UNMoreProject.vue?vue&type=script&lang=js&"
import style0 from "./UNMoreProject.vue?vue&type=style&index=0&id=08af9a61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af9a61",
  null
  
)

export default component.exports